import { render, staticRenderFns } from "./SpinalAssessmentAction.vue?vue&type=template&id=16a5f5ec&scoped=true&"
import script from "./SpinalAssessmentAction.vue?vue&type=script&lang=js&"
export * from "./SpinalAssessmentAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a5f5ec",
  null
  
)

export default component.exports